import { LiveEvent } from '../../core/models/live-events'
import { firstValueFrom } from 'rxjs'
import { TranslateService } from '@ngx-translate/core'

export const getLineSrcImage = (event: LiveEvent) => {
  return event ? `./assets/icon/lines/${event.lineName}.svg` : ''
}

export const getEventSrcImage = (event: LiveEvent) => {
  return event ? `./assets/svgs/live-events/${event.type.toLowerCase()}.svg` : ''
}

export const buildEventInformationLabel = async ({ translationService, eventsCount }: {
  translationService: TranslateService;
  eventsCount: [string, number][]
}): Promise<string> => {
  if (eventsCount.length === 0) return ''

  const eventLabels = {
    AGENT: 'app.shared.event.eventType.agent',
    INCIDENT: 'app.shared.event.eventType.incident',
    CONTRACTOR: 'app.shared.event.eventType.contractor',
    HELPER: 'app.shared.event.eventType.helper',
    REQUESTED_AGENT: 'app.shared.event.eventType.requestedAgent',
    CULTURAL: 'app.shared.event.eventType.plan',
    MANIFESTATION: 'app.shared.event.eventType.plan',
    OTHER: 'app.shared.event.eventType.plan',
    SPORT: 'app.shared.event.eventType.plan',
    WORKS: 'app.shared.event.eventType.plan'
  }
  const AND_LABEL = 'app.shared.event.detail.and'
  const COMMA_LABEL = 'app.shared.event.detail.comma'

  const translationKeys = [...Object.values(eventLabels), AND_LABEL, COMMA_LABEL]
  const translations: Promise<string> = await firstValueFrom(translationService.get(translationKeys))

  const formattedEvents = eventsCount.map(([eventType, count]) => `${count} ${formatPluralization(translations[eventLabels[eventType]], count)}`)

  const lastEvent = formattedEvents.pop()
  const eventList = formattedEvents.length > 0
    ? `${formattedEvents.join(translations[COMMA_LABEL])} ${translations[AND_LABEL]} ${lastEvent}`
    : lastEvent

  return surroundWithParentheses(eventList)
}

const formatPluralization = (text: string, count: number) => {
  return count <= 1 ? text : `${text}s`
}

const surroundWithParentheses = (text: string) => {
  return `(${text.trim()})`
}
